import './index.scss'
import ContentLoader from '../loader'

const SectionLoader = ({loader}) => {
    return loader && <div className="content-body-loader">
        <ContentLoader/>
    </div>
}

export default SectionLoader
